import { OrderCancellation } from "lib/types/generated/graphql-types"
import { OrderOperations } from "./OrderOperations"

export class Cancellations extends OrderOperations {
  constructor(cancellation: OrderCancellation[]) {
    super(cancellation)
  }

  public completedCancellations(): OrderCancellation[] {
    return this.completedList() as OrderCancellation[]
  }

  public orderCancelled(orderId: string): OrderCancellation | undefined {
    return this.completedCancellations().find((cancellation) => cancellation.orderId === orderId)
  }

  public getOngoingCancellation(): OrderCancellation {
    const ongoingList = this.ongoingList() as OrderCancellation[]
    return ongoingList[0]
  }

  public getFailedCancellation(): OrderCancellation {
    const failedList = this.failedList() as OrderCancellation[]
    return failedList[0]
  }

  public getPendingCancellation(): OrderCancellation {
    const pendingList = this.pendingList() as OrderCancellation[]
    return pendingList[0]
  }
}
